import { memo } from 'react';
import LazyLoad from 'react-lazyload';
import ossImgCompress, { canUseWebp } from '@/utils/ossImgCompress';
import styles from './index.module.less';

/**
 * @param {PropsWithChildren} props
 * @returns
 */
const Index = ({ children, ...props }) => {
  let {
    src,
    data_src,
    dataSlideSrc,
    offset = 400,
    ratio,
    className,
    coverClassName,
    outerStyle = {},
    style = { width: '100%' },
    onClick,
    webp,
    quality = 90,
    type = 'img',
    key,
    onLoad,
    ...restProps
  } = props;

  src = webp || canUseWebp(src) ? ossImgCompress(src, { webp: true, quality }) : src;
  data_src =
    webp === false
      ? data_src
      : webp || canUseWebp(data_src)
      ? ossImgCompress(data_src, { webp: true, quality })
      : data_src;

  dataSlideSrc =
    webp === false
      ? dataSlideSrc
      : webp || canUseWebp(dataSlideSrc)
      ? ossImgCompress(dataSlideSrc, { webp: true, quality })
      : dataSlideSrc;

  const hasRatio = Array.isArray(ratio) && type !== 'cover';

  return data_src || dataSlideSrc ? (
    <div key={key} className={[styles.lazyimg, className].join(' ')} style={outerStyle}>
      <span
        className={styles.ratioSpan}
        style={{ paddingBottom: Array.isArray(ratio) && `${(ratio[1] / ratio[0]) * 100}%` }}
      />
      <img
        {...restProps}
        data-src={data_src}
        data-slide-src={dataSlideSrc}
        style={style}
        onClick={onClick}
        src=''
        alt=''
        onLoad={onLoad}
      />
    </div>
  ) : (
    <LazyLoad offset={offset} className={[styles.lazyimg, className].join(' ')} style={outerStyle}>
      {hasRatio && <span className={styles.ratioSpan} style={{ paddingBottom: `${(ratio[1] / ratio[0]) * 100}%` }} />}
      {type === 'img' && <img onLoad={onLoad} {...restProps} src={src} style={style} onClick={onClick} alt='' />}
      {type === 'cover' && (
        <div
          {...restProps}
          className={coverClassName ?? styles.cover}
          style={{ backgroundImage: `url(${src})`, ...style }}
          onClick={onClick}
        >
          {children}
        </div>
      )}
    </LazyLoad>
  );
};

const LazyLoadImg = memo(Index);
export default LazyLoadImg;
